import 'amfe-flexible'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { router } from './router'
import VueApexCharts from 'vue-apexcharts'
import { helper } from './helper'
import { Tabbar, TabbarItem, Icon, NavBar, Panel, Divider, PullRefresh, Toast, Loading, Tab, Tabs, Skeleton, SwipeCell, Card, Button, ContactCard, ContactList, Locale, Sticky, Grid, GridItem, List, Cell, CellGroup, Field, ActionSheet, Swipe, SwipeItem, AddressEdit, Uploader, Stepper, Form, Popup, Dialog, Picker, Calendar, NumberKeyboard, Notify, Tag, Search, IndexBar, IndexAnchor, AddressList, Collapse, CollapseItem, PasswordInput } from 'vant';
import VueBarcodeScanner from 'vue-barcode-scanner'
import store from './store/index.js'

import { Image as VanImage } from 'vant';
Vue.use(VanImage);
let options = {
  sound: true, // default is false
  soundSrc: '/static/sound.wav', // default is blank
  sensitivity: 300, // default is 100
  requiredAttr: true, // default is false
  controlSequenceKeys: ['NumLock', 'Clear'], // default is null
  callbackAfterTimeout: true // default is false
}

Vue.use(VueBarcodeScanner, options)

Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Tag);
Vue.use(Search);
Vue.use(AddressList);
Vue.use(Card);

import 'vant/lib/collapse/style';
import 'vant/lib/collapse-item/style';
import 'vant/lib/card/style';
import 'vant/lib/address-list/style';
import 'vant/lib/index-bar/style';
import 'vant/lib/index-anchor/style';
import 'vant/lib/search/style';
import 'vant/lib/tag/style';
import 'vant/lib/number-keyboard/style';
import 'vant/lib/calendar/style';
import 'vant/lib/tabbar/style';
import 'vant/lib/tabbar-item/style';
import 'vant/lib/nav-bar/style';
import 'vant/lib/panel/style';
import 'vant/lib/divider/style';
import 'vant/lib/pull-refresh/style';
import 'vant/lib/toast/style';
import 'vant/lib/loading/style';
import 'vant/lib/tab/style';
import 'vant/lib/tabs/style';
import 'vant/lib/skeleton/style';
import 'vant/lib/popup/style';
import 'vant/lib/button/style';
import 'vant/lib/contact-card/style';
import 'vant/lib/contact-list/style';
import 'vant/lib/locale/style';
import trTR from 'vant/lib/locale/lang/tr-TR';
import 'vant/lib/grid/style';
import 'vant/lib/grid-item/style';
import 'vant/lib/list/style';
import 'vant/lib/cell/style';
import 'vant/lib/field/style';
import 'vant/lib/action-sheet/style';
import 'vant/lib/uploader/style';
import 'vant/lib/dialog/style';
import 'vant/lib/stepper/style';
import 'vant/lib/swipe-cell/style';
import 'vant/lib/form/style';
import 'vant/lib/picker/style';
import 'vant/lib/swipe-item/style';
import 'vant/lib/swipe/style';
import 'vant/lib/notify/style';
Vue.use(Notify);
Vue.use(NumberKeyboard);
Vue.use(Calendar);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(Stepper);
Vue.use(Uploader);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Icon);
Vue.use(NavBar);
Vue.use(Panel);
Vue.use(Divider);
Vue.use(PullRefresh);
Vue.use(Toast);
Vue.use(Loading);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Skeleton);
Vue.use(ContactCard);
Vue.use(ContactList);
//Vue.use(ContactEdit);
Vue.use(SwipeCell);
Vue.use(Card);
Vue.use(Button);
//Vue.use(Locale);
Locale.use('tr-Tr', trTR);
Vue.use(Sticky);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(List);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(SwipeCell);
Vue.use(ActionSheet);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popup);
Vue.use(PasswordInput);
//Vue.use(Grid);
//Vue.use(GridItem);

Vue.component('apexchart', VueApexCharts)
Vue.config.productionTip = false
//alert("drg")
/* eslint-disable no-new */
new Vue({
  render: h => h(App),
  router, store
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js